import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>Not found</h1>
      <p className='lead'>The page you are looking for doesn't exist. </p>
    </div>
  );
};

export default NotFound;
